import * as actions from "./actions";

const initialState = {
  initial: false,
  data: [],
  isFetchingPending: false,
  isApprovingPending: false,
  isRejectingPending: false,
  isPromotingPending: false,
  error: null,
};

const varietyApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Pending Varieties
    case actions.FETCH_PENDING_VARIETIES.REQUEST:
      return {
        ...state,
        isFetchingPending: true,
        error: null,
      };

    case actions.FETCH_PENDING_VARIETIES.SUCCESS:
      return {
        ...state,
        initial: true,
        isFetchingPending: false,
        data: action.payload.data,
        error: null,
      };

    case actions.FETCH_PENDING_VARIETIES.FAILURE:
      return {
        ...state,
        isFetchingPending: false,
        error: action.payload,
      };

    // Approve Variety
    case actions.APPROVE_VARIETY.REQUEST:
      return {
        ...state,
        isApprovingPending: true,
        error: null,
      };

    case actions.APPROVE_VARIETY.SUCCESS:
      return {
        ...state,
        isApprovingPending: false,
        error: null,
      };

    case actions.APPROVE_VARIETY.FAILURE:
      return {
        ...state,
        isApprovingPending: false,
        error: action.payload.error,
      };

    // Reject Variety
    case actions.REJECT_VARIETY.REQUEST:
      return {
        ...state,
        isRejectingPending: true,
        error: null,
      };

    case actions.REJECT_VARIETY.SUCCESS:
      return {
        ...state,
        isRejectingPending: false,
        error: null,
      };

    case actions.REJECT_VARIETY.FAILURE:
      return {
        ...state,
        isRejectingPending: false,
        error: action.payload.error,
      };

    // Promote Variety
    case actions.PROMOTE_VARIETY.REQUEST:
      return {
        ...state,
        isPromotingPending: true,
        error: null,
      };

    case actions.PROMOTE_VARIETY.SUCCESS:
      return {
        ...state,
        isPromotingPending: false,
        error: null,
      };

    case actions.PROMOTE_VARIETY.FAILURE:
      return {
        ...state,
        isPromotingPending: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
};

export default varietyApprovalReducer;
